/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosRichTextProps } from "../rich-text";
import { CosmosTextProps } from "./CosmosText.atom";
import { CosmosTextAs, CosmosTextVariants, VariantType } from "./text.types";

export const getTextAs = (props: CosmosTextProps | CosmosRichTextProps): CosmosTextAs | null | undefined => {
	let as = props.as;
	if (!props.as && props.children) {
		if (props.variant?.startsWith("paragraph")) {
			as = "div";
		}
		if (props.variant === "heading2XL") {
			as = "h1";
		}
		if (props.variant === "headingXL") {
			as = "h2";
		}
		if (props.variant === "headingLG") {
			as = "h3";
		}
		if (props.variant === "headingMD") {
			as = "h4";
		}
		if (props.variant === "headingSM") {
			as = "h5";
		}
		if (props.variant === "eyebrowLG") {
			as = "h6";
		}
	}

	return as;
};

export const getTextVariantType = (variant?: CosmosTextVariants | null): VariantType => {
	let variantType: VariantType = "heading";

	if (variant?.includes("paragraph")) {
		variantType = "paragraph";
	} else if (variant?.includes("ui")) {
		variantType = "ui";
	} else if (variant?.includes("eyebrow")) {
		variantType = "eyebrow";
	}

	return variantType;
};
